import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=22e973ce&scoped=true"
import script from "./Credentials.vue?vue&type=script&lang=js"
export * from "./Credentials.vue?vue&type=script&lang=js"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=22e973ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e973ce",
  null
  
)

export default component.exports